import { render, staticRenderFns } from "./about-home.vue?vue&type=template&id=86453342&scoped=true&"
import script from "./about-home.vue?vue&type=script&lang=js&"
export * from "./about-home.vue?vue&type=script&lang=js&"
import style0 from "./about-home.vue?vue&type=style&index=0&id=86453342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86453342",
  null
  
)

export default component.exports